import { BaseFetch } from "../main-model"
export default class PerformanceModel extends BaseFetch {
    getPerformanceBy = (data) =>
    this.authFetch({
      url: "performance/getPerformanceBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getPerformanceById = (data) =>
    this.authFetch({
      url: "performance/getPerformanceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updatePerformanceById = (data) =>
    this.authFetch({
      url: "performance/updatePerformanceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertPerformance = (data) =>
    this.authFetch({
      url: "performance/insertPerformance",
      method: "POST",
      body: JSON.stringify(data),
    })
    deletePerformanceById = (data) =>
    this.authFetch({
      url: "performance/deletePerformanceById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
